import React, { useState, useEffect } from 'react';
import './HardwareInclusiveCounter.css';
import { useTranslation } from "react-i18next";
import EcoProButton from '../../../../components/shared/button/button';
import AdminFormInput from '../../../../components/AdminPortal/Shared/FormElements/FormInput/FormInput';
import Loader from '../../../../components/shared/loader/Loader';
import AdminAlert from '../../../../components/AdminPortal/AdminAlert/AdminAlert';
import { useDispatch, useSelector } from "react-redux";
import { addHardwareInclusiveCounter, fetchHardwareInclusiveStockCounter, resetHardwareInclusiveCounterAdd, resetHardwareInclusiveCounterFetch, resetHardwareInclusiveCounterUpdate, updateHardwareInclusiveCounter } from '../../../../actions/AdminPortal/HardwareInclusiveCounter';
import PageHeader from '../../../../components/AdminPortal/Shared/PageHeader/PageHeader';
import { ENVSettings } from '../../../../constants/ENVSettings';
import { FetchPrinterTypes } from '../../../../actions/Web/Customer/SignUp';

const HardwareInclusiveCounter = () => {
    const { t } = useTranslation("Admintranslation");
    const dispatch = useDispatch();
    const [printerTypeId, setPrinterTypeId] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedPrinterType, setSelectedPrinterType] = useState('');
    const [showDetails, setShowDetails] = useState(false);
    const [value, setValue] = useState();
    const countryList = ENVSettings.COUNTRIES;
    const printerTypesResp = useSelector(state => state.PrinterTypes);
    const {
        data: fetchCounterData,
        error: fetchCounterError,
        loading: fetchCounterLoading,
        success: fetchCounterSuccess,
    } = useSelector((state) => state.ADMIN.HardwareInclusiveStockCounter_FETCH);

    const {
        success: addCounterSuccess,
        loading: addCounterLoading
    } = useSelector((state) => state.ADMIN.HardwareInclusiveCounter_ADD);

    const {
        success: updateCounterSuccess,
        loading:updateCounterLoading
    } = useSelector((state) => state.ADMIN.HardwareInclusiveCounter_UPDATE);

    useEffect(() => {
        dispatch(FetchPrinterTypes());
    }, [dispatch])
    useEffect(() => {
    
        return () => {
         dispatch(resetHardwareInclusiveCounterUpdate());
         dispatch(resetHardwareInclusiveCounterAdd())
         dispatch(resetHardwareInclusiveCounterFetch())
        };
      }, [dispatch]);

    useEffect(() => {
        if (fetchCounterData?.hardwareInclusivePrinterStockDetailsViewModel?.length > 0) {
            const availableUnits = fetchCounterData.hardwareInclusivePrinterStockDetailsViewModel[0].availableUnits;
            setValue(availableUnits);
        }
        else if (fetchCounterData?.hardwareInclusivePrinterStockDetailsViewModel == null) {
            setValue(0)
        }
        else {
            setValue(0)
        }
    }, [fetchCounterData]);
  
    const handleSearch = () => {
        dispatch(fetchHardwareInclusiveStockCounter(selectedCountry, selectedPrinterType));
        setShowDetails(true);
    };
    const handleValueChange = (e) => {
        setValue(e.target.value)
    }
    const handleAdd = () => {
        dispatch(addHardwareInclusiveCounter(printerTypeId, value, selectedCountry, true))
        setValue(0)
        setShowDetails(false)
    }
    const handleUpdate = () => {
        dispatch(updateHardwareInclusiveCounter(printerTypeId, value, selectedCountry, true))
        setValue(0)
        setShowDetails(false)
    }
    const handleCountryChange = (e) => {
        setSelectedCountry(e.target.value);
        setShowDetails(false)
    };

    const handlePrinterTypeChange = (e) => {
        setSelectedPrinterType(e.target.value)
        setShowDetails(false)
        if (Array.isArray(printerTypesResp?.printerTypes)) {
            const selectedPrinter = printerTypesResp?.printerTypes?.find(
                (printer) => printer.type === e.target.value
            );
            if (selectedPrinter) {
                const printerTypeId = selectedPrinter.printerTypeId;
                setPrinterTypeId(printerTypeId);
            }
        }
    }
    const handleCancel = () => {
        setShowDetails(false)
        setValue(0)
    }

    return (<>
        {(fetchCounterLoading || printerTypesResp.loading || addCounterLoading || updateCounterLoading) && <Loader setOverlay={true}></Loader>}
        <div className="hardware-counter-container">
            <div className="admin-users-add-header">
                <PageHeader pageTitle={t("HARDWARE_INCLUSIVE_COUNTER.PAGE_TITLE")} pageSubTitle={t('HARDWARE_INCLUSIVE_COUNTER.PAGE_SUBTITLE')} ></PageHeader>
            </div>
            {fetchCounterError && <AdminAlert alert_variant="alert-danger" isVisible={true}>{t("HARDWARE_INCLUSIVE_COUNTER.FETCH_ERROR")}</AdminAlert>}
            {fetchCounterSuccess && <AdminAlert alert_variant="alert-success" isVisible={true}>{t("HARDWARE_INCLUSIVE_COUNTER.FETCH_SUCCESS")}</AdminAlert>}
            {updateCounterSuccess && <AdminAlert alert_variant="alert-success" isVisible={true}> {t("HARDWARE_INCLUSIVE_COUNTER.UPDATE_SUCCESS")}</AdminAlert>}
            {addCounterSuccess && <AdminAlert alert_variant="alert-success" isVisible={true}> {t("HARDWARE_INCLUSIVE_COUNTER.ADD_SUCCESS")}</AdminAlert>}
            {printerTypesResp.error && <AdminAlert alert_variant="alert-danger">{printerTypesResp.error}</AdminAlert>}
            <div className="admin-user-add-edit-wrapper mt-20 cont">
                <div className="hardware-counter-section">

                    <div className='counter-items'>
                        <div className="counter-item">
                            <label className="counter-label">{t("HARDWARE_INCLUSIVE_COUNTER.COUNTRY_LABEL")}</label>
                            <select
                                className="counter-select"
                                value={selectedCountry}
                                onChange={(e) => handleCountryChange(e)}
                            >
                                <option value="">{t("HARDWARE_INCLUSIVE_COUNTER.COUNTRY_DEFAULT_OPTION")}</option>
                                {countryList.map((country) => (
                                    <option
                                        className="counter-option"
                                        key={country.code2}
                                        value={country.code2}
                                    >
                                        {country.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="counter-item">
                            <label className="counter-label">{t("HARDWARE_INCLUSIVE_COUNTER.PRINTER_TYPE_LABEL")}</label>
                            <select
                                className="counter-select"
                                value={selectedPrinterType}
                                onChange={(e) => handlePrinterTypeChange(e)}
                            >
                                <option value="">{t("HARDWARE_INCLUSIVE_COUNTER.PRINTER_TYPE_DEFAULT_OPTION")}</option>
                                {Array.isArray(printerTypesResp?.printerTypes) ? (
                                    printerTypesResp.printerTypes.map((printerType) => (
                                        <option
                                            className="counter-option"
                                            key={printerType.type}
                                            value={printerType.type}
                                        >
                                            {printerType.type}
                                        </option>
                                    ))
                                ) : null}
                            </select>
                        </div>
                        <div className="save-container">
                            <EcoProButton
                                cname="default hardwareinccounter-page-save-btn"
                                onBtnClick={() => handleSearch()}
                            >
                                {t("BTN_TEXTS.SEARCH")}
                            </EcoProButton>
                        </div>
                    </div>
                </div>

                {(showDetails && fetchCounterSuccess) && (
                    <div className="hardware-counter-details">
                        {fetchCounterData?.hardwareInclusivePrinterStockDetailsViewModel == null ? (
                            <div className="hardware-counter-add">
                                <div className="available-units inline"> {t("HARDWARE_INCLUSIVE_COUNTER.AVAILABLE_UNITS_LABEL")}  <AdminFormInput
                                    className="counter-input"
                                    type="number"
                                    value={value}
                                    onChange={(e) => handleValueChange(e)}
                                /></div>
                                <div>
                                    <EcoProButton
                                        cname="default hardwareinccounter-page-save-btn"
                                        onBtnClick={() => handleAdd()}
                                    >
                                        {t("BTN_TEXTS.ADD")}
                                    </EcoProButton>
                                    <EcoProButton
                                        cname="hardwareinccounter-page-cancel-btn"
                                        onBtnClick={() => handleCancel()}
                                    >
                                        {t("BTN_TEXTS.CANCEL")}
                                    </EcoProButton>
                                </div>
                            </div>
                        ) : (
                            <div className="hardware-counter-update">
                                <div className="available-units inline"> {t("HARDWARE_INCLUSIVE_COUNTER.AVAILABLE_UNITS_LABEL")} <AdminFormInput
                                    className="counter-input"
                                    type="number"
                                    value={value}
                                    onChange={(e) => handleValueChange(e)}
                                /></div>
                                <div>
                                    <EcoProButton
                                        cname="default hardwareinccounter-page-save-btn"
                                        onBtnClick={() => handleUpdate()}
                                    >
                                        {t("BTN_TEXTS.UPDATE")}
                                    </EcoProButton>

                                    <EcoProButton
                                        cname="hardwareinccounter-page-cancel-btn"
                                        onBtnClick={() => handleCancel()}
                                    >
                                        {t("BTN_TEXTS.CANCEL")}
                                    </EcoProButton>
                                </div>
                            </div>
                        )}
                    </div>
                )}

            </div>

        </div>

    </>

    );
};

export default HardwareInclusiveCounter;